import type { NamespaceCatalog } from '@/i18n/ns';

const connectionsActionsCopy = {
  en: {
    loadError: 'Could not load connections.',
    startError: 'Could not start the connection.',
    providerCheckFailed:
      'We could not check the provider right now. Your account may still have connected. Check Connections before trying again.',
    providerAuthorizationFailed:
      '{name} authorization did not finish at the provider. The account was not connected. Check the provider window for a more specific reason, then try again.',
    providerReturnedMissing:
      'The provider returned, but {name} has not appeared yet. Check that the account and requested permissions were approved, then try again.',
    notConnected:
      '{name} was not connected. The authorization window may have been closed or canceled. Try again when you are ready.',
    disconnectPrivate: 'Disconnect {name} for only you? Access stops until it is connected again.',
    disconnectCompany:
      'Disconnect {name} for everyone at {company}? Access stops until it is connected again.',
    disconnected: '{name} is disconnected.',
    disconnectError: 'Could not disconnect.',
    stoppedWaiting:
      'Stopped waiting. Your provider may still finish authorizing. Reopen Connections to check the latest status.',
    saveSnapshot: 'Save a snapshot to Library',
    requestApproval: 'Request approval',
    accessSuffix: 'Access stops until it is connected again.',
  },
  bg: {
    loadError: 'Връзките не можаха да се заредят.',
    startError: 'Връзката не можа да бъде стартирана.',
    providerCheckFailed:
      'В момента не успяхме да проверим доставчика. Възможно е акаунтът ви все пак да е свързан. Проверете „Връзки“, преди да опитате отново.',
    providerAuthorizationFailed:
      'Упълномощаването на {name} не завърши при доставчика. Акаунтът не беше свързан. Проверете прозореца на доставчика за по-конкретна причина и опитайте отново.',
    providerReturnedMissing:
      'Доставчикът ви върна, но {name} все още не се е появил. Проверете дали акаунтът и поисканите разрешения са одобрени и опитайте отново.',
    notConnected:
      '{name} не беше свързан. Прозорецът за упълномощаване може да е бил затворен или отменен. Опитайте отново, когато сте готови.',
    disconnectPrivate:
      'Да прекъснете ли връзката с {name} само за себе си? Достъпът ще бъде спрян, докато връзката не бъде установена отново.',
    disconnectCompany:
      'Да прекъснете ли връзката с {name} за всички в {company}? Достъпът ще бъде спрян, докато връзката не бъде установена отново.',
    disconnected: 'Връзката с {name} е прекъсната.',
    disconnectError: 'Връзката не можа да бъде прекъсната.',
    stoppedWaiting:
      'Спряхме изчакването. Доставчикът ви може все още да завършва упълномощаването. Отворете отново „Връзки“, за да проверите последния статус.',
    saveSnapshot: 'Запазване на моментна снимка в библиотеката',
    requestApproval: 'Заявяване на одобрение',
    accessSuffix: 'Достъпът ще бъде преустановен, докато не бъде свързан отново.',
  },
  hr: {
    loadError: 'Nije moguće učitati veze.',
    startError: 'Nije moguće pokrenuti vezu.',
    providerCheckFailed:
      'Trenutačno nije moguće provjeriti pružatelja. Vaš račun možda je ipak povezan. Provjerite Veze prije ponovnog pokušaja.',
    providerAuthorizationFailed:
      'Autorizacija za {name} nije dovršena kod pružatelja. Račun nije povezan. U prozoru pružatelja provjerite konkretniji razlog i pokušajte ponovno.',
    providerReturnedMissing:
      'Pružatelj je odgovorio, ali {name} se još nije pojavila. Provjerite jesu li račun i zatražene dozvole odobreni, a zatim pokušajte ponovno.',
    notConnected:
      'Veza s {name} nije uspostavljena. Prozor za autorizaciju možda je zatvoren ili je postupak otkazan. Pokušajte ponovno kada budete spremni.',
    disconnectPrivate:
      'Prekinuti vezu s {name} samo za vas? Pristup se prekida dok se veza ponovno ne uspostavi.',
    disconnectCompany:
      'Prekinuti vezu s {name} za sve u tvrtki {company}? Pristup se prekida dok se veza ponovno ne uspostavi.',
    disconnected: 'Veza s {name} je prekinuta.',
    disconnectError: 'Nije moguće prekinuti vezu.',
    stoppedWaiting:
      'Čekanje je prekinuto. Pružatelj možda još dovršava autorizaciju. Ponovno otvorite Veze da biste provjerili najnoviji status.',
    saveSnapshot: 'Spremi snimku u Knjižnicu',
    requestApproval: 'Zatraži odobrenje',
    accessSuffix: 'Pristup se prekida dok se veza ponovno ne uspostavi.',
  },
  cs: {
    loadError: 'Nepodařilo se načíst připojení.',
    startError: 'Připojení se nepodařilo spustit.',
    providerCheckFailed:
      'Poskytovatele se teď nepodařilo ověřit. Váš účet může být přesto připojený. Před dalším pokusem zkontrolujte Připojení.',
    providerAuthorizationFailed:
      'Autorizace {name} u poskytovatele nebyla dokončena. Účet nebyl připojen. Zkontrolujte okno poskytovatele, kde najdete konkrétnější důvod, a potom to zkuste znovu.',
    providerReturnedMissing:
      'Poskytovatel odpověděl, ale {name} se zatím nezobrazuje. Zkontrolujte, zda byly schváleny účet a požadovaná oprávnění, a potom to zkuste znovu.',
    notConnected:
      '{name} nebyl připojen. Autorizační okno mohlo být zavřeno nebo zrušeno. Až budete připraveni, zkuste to znovu.',
    disconnectPrivate:
      'Odpojit {name} jen pro vás? Přístup se zastaví, dokud nebude znovu připojen.',
    disconnectCompany:
      'Odpojit {name} pro všechny v organizaci {company}? Přístup se zastaví, dokud nebude znovu připojen.',
    disconnected: '{name} je odpojen.',
    disconnectError: 'Nepodařilo se odpojit.',
    stoppedWaiting:
      'Čekání bylo ukončeno. Poskytovatel může autorizaci stále dokončovat. Znovu otevřete Připojení a zkontrolujte nejnovější stav.',
    saveSnapshot: 'Uložit snímek do Knihovny',
    requestApproval: 'Požádat o schválení',
    accessSuffix: 'Přístup nebude dostupný, dokud se znovu nepřipojí.',
  },
  da: {
    loadError: 'Forbindelser kunne ikke indlæses.',
    startError: 'Forbindelsen kunne ikke startes.',
    providerCheckFailed:
      'Vi kunne ikke kontrollere udbyderen lige nu. Din konto kan stadig være blevet forbundet. Tjek Forbindelser, før du prøver igen.',
    providerAuthorizationFailed:
      'Godkendelsen af {name} blev ikke gennemført hos udbyderen. Kontoen blev ikke forbundet. Tjek udbydervinduet for en mere specifik årsag, og prøv derefter igen.',
    providerReturnedMissing:
      'Udbyderen vendte tilbage, men {name} er endnu ikke blevet vist. Kontrollér, at kontoen og de anmodede tilladelser blev godkendt, og prøv derefter igen.',
    notConnected:
      '{name} blev ikke forbundet. Godkendelsesvinduet er muligvis blevet lukket eller annulleret. Prøv igen, når du er klar.',
    disconnectPrivate:
      'Vil du afbryde forbindelsen til {name} kun for dig? Adgangen stopper, indtil den forbindes igen.',
    disconnectCompany:
      'Vil du afbryde forbindelsen til {name} for alle hos {company}? Adgangen stopper, indtil den forbindes igen.',
    disconnected: 'Forbindelsen til {name} er afbrudt.',
    disconnectError: 'Forbindelsen kunne ikke afbrydes.',
    stoppedWaiting:
      'Du er stoppet med at vente. Udbyderen kan stadig være i gang med at gennemføre godkendelsen. Åbn Forbindelser igen for at se den seneste status.',
    saveSnapshot: 'Gem et øjebliksbillede i Bibliotek',
    requestApproval: 'Anmod om godkendelse',
    accessSuffix: 'Adgangen ophører, indtil den er tilsluttet igen.',
  },
  nl: {
    loadError: 'Kan verbindingen niet laden.',
    startError: 'Kan de verbinding niet starten.',
    providerCheckFailed:
      'We kunnen de provider momenteel niet controleren. Je account is mogelijk toch verbonden. Controleer Verbindingen voordat je het opnieuw probeert.',
    providerAuthorizationFailed:
      'De autorisatie van {name} bij de provider is niet voltooid. Het account is niet verbonden. Controleer het providervenster voor een specifiekere reden en probeer het daarna opnieuw.',
    providerReturnedMissing:
      'De provider heeft gereageerd, maar {name} wordt nog niet weergegeven. Controleer of het account en de aangevraagde machtigingen zijn goedgekeurd en probeer het daarna opnieuw.',
    notConnected:
      '{name} is niet verbonden. Het autorisatievenster is mogelijk gesloten of geannuleerd. Probeer het opnieuw wanneer je klaar bent.',
    disconnectPrivate:
      '{name} alleen voor jou ontkoppelen? De toegang wordt stopgezet totdat de verbinding opnieuw tot stand is gebracht.',
    disconnectCompany:
      '{name} voor iedereen bij {company} ontkoppelen? De toegang wordt stopgezet totdat de verbinding opnieuw tot stand is gebracht.',
    disconnected: '{name} is ontkoppeld.',
    disconnectError: 'Kan de verbinding niet verbreken.',
    stoppedWaiting:
      'Wachten gestopt. Je provider kan de autorisatie nog steeds voltooien. Open Verbindingen opnieuw om de nieuwste status te controleren.',
    saveSnapshot: 'Momentopname opslaan in Bibliotheek',
    requestApproval: 'Goedkeuring aanvragen',
    accessSuffix: 'Toegang stopt totdat het opnieuw is verbonden.',
  },
  et: {
    loadError: 'Ühenduste laadimine ebaõnnestus.',
    startError: 'Ühenduse käivitamine ebaõnnestus.',
    providerCheckFailed:
      'Pakkujat ei saanud praegu kontrollida. Teie konto võib siiski olla ühendatud. Kontrollige enne uuesti proovimist jaotist Ühendused.',
    providerAuthorizationFailed:
      '{name} autoriseerimine pakkuja juures ei jõudnud lõpule. Kontot ei ühendatud. Täpsema põhjuse leidmiseks kontrollige pakkuja akent ja proovige seejärel uuesti.',
    providerReturnedMissing:
      'Pakkuja vastas, kuid {name} pole veel ilmunud. Kontrollige, kas konto ja taotletud õigused kiideti heaks, ning proovige seejärel uuesti.',
    notConnected:
      '{name} ei saanud ühendada. Autoriseerimisaken võidi sulgeda või tühistada. Proovige uuesti, kui olete valmis.',
    disconnectPrivate:
      'Kas katkestada {name} ühendus ainult teie jaoks? Juurdepääs peatub, kuni ühendus uuesti luuakse.',
    disconnectCompany:
      'Kas katkestada {name} ühendus kõigi jaoks ettevõttes {company}? Juurdepääs peatub, kuni ühendus uuesti luuakse.',
    disconnected: '{name} ühendus on katkestatud.',
    disconnectError: 'Ühenduse katkestamine ebaõnnestus.',
    stoppedWaiting:
      'Ootamine lõpetati. Pakkuja võib autoriseerimise siiski lõpule viia. Viimase oleku kontrollimiseks avage uuesti jaotis Ühendused.',
    saveSnapshot: 'Salvesta hetktõmmis teeki',
    requestApproval: 'Taotle kinnitamist',
    accessSuffix: 'Juurdepääs peatub, kuni see uuesti ühendatakse.',
  },
  fi: {
    loadError: 'Yhteyksiä ei voitu ladata.',
    startError: 'Yhteyttä ei voitu käynnistää.',
    providerCheckFailed:
      'Palveluntarjoajaa ei voitu tarkistaa juuri nyt. Tilisi on ehkä silti yhdistetty. Tarkista Yhteydet ennen kuin yrität uudelleen.',
    providerAuthorizationFailed:
      'Palveluntarjoaja ei saanut vahvistettua käyttöoikeutta kohteelle {name}. Tiliä ei yhdistetty. Tarkista palveluntarjoajan ikkuna saadaksesi tarkemman syyn ja yritä sitten uudelleen.',
    providerReturnedMissing:
      'Palveluntarjoaja vastasi, mutta {name} ei ole vielä näkyvissä. Tarkista, että tili ja pyydetyt käyttöoikeudet hyväksyttiin, ja yritä sitten uudelleen.',
    notConnected:
      'Kohdetta {name} ei yhdistetty. Valtuutusikkuna on ehkä suljettu tai peruutettu. Yritä uudelleen, kun olet valmis.',
    disconnectPrivate:
      'Katkaistaanko yhteys kohteeseen {name} vain sinulta? Käyttöoikeus lakkaa, kunnes yhteys yhdistetään uudelleen.',
    disconnectCompany:
      'Katkaistaanko yhteys kohteeseen {name} kaikilta yrityksessä {company}? Käyttöoikeus lakkaa, kunnes yhteys yhdistetään uudelleen.',
    disconnected: 'Yhteys kohteeseen {name} on katkaistu.',
    disconnectError: 'Yhteyttä ei voitu katkaista.',
    stoppedWaiting:
      'Odotus lopetettiin. Palveluntarjoaja saattaa silti viimeistellä valtuutuksen. Avaa Yhteydet uudelleen ja tarkista uusin tila.',
    saveSnapshot: 'Tallenna tilannekuva Kirjastoon',
    requestApproval: 'Pyydä hyväksyntää',
    accessSuffix: 'Käyttö estyy, kunnes yhteys muodostetaan uudelleen.',
  },
  fr: {
    loadError: 'Impossible de charger les connexions.',
    startError: 'Impossible de démarrer la connexion.',
    providerCheckFailed:
      'Impossible de vérifier le fournisseur pour le moment. Votre compte est peut-être tout de même connecté. Vérifiez les connexions avant de réessayer.',
    providerAuthorizationFailed:
      'L’autorisation de {name} n’a pas abouti auprès du fournisseur. Le compte n’a pas été connecté. Consultez la fenêtre du fournisseur pour connaître la raison exacte, puis réessayez.',
    providerReturnedMissing:
      'Le fournisseur a répondu, mais {name} n’apparaît pas encore. Vérifiez que le compte et les autorisations demandées ont été approuvés, puis réessayez.',
    notConnected:
      '{name} n’a pas été connecté. La fenêtre d’autorisation a peut-être été fermée ou annulée. Réessayez lorsque vous serez prêt.',
    disconnectPrivate:
      'Déconnecter {name} pour vous uniquement ? L’accès sera interrompu jusqu’à une nouvelle connexion.',
    disconnectCompany:
      'Déconnecter {name} pour tout le monde chez {company} ? L’accès sera interrompu jusqu’à une nouvelle connexion.',
    disconnected: '{name} est déconnecté.',
    disconnectError: 'Impossible de déconnecter.',
    stoppedWaiting:
      'Attente interrompue. Votre fournisseur peut encore terminer l’autorisation. Rouvrez les connexions pour vérifier le dernier état.',
    saveSnapshot: 'Enregistrer un instantané dans la bibliothèque',
    requestApproval: 'Demander une approbation',
    accessSuffix: 'L’accès est suspendu jusqu’à la reconnexion.',
  },
  de: {
    loadError: 'Verbindungen konnten nicht geladen werden.',
    startError: 'Die Verbindung konnte nicht gestartet werden.',
    providerCheckFailed:
      'Der Anbieter konnte momentan nicht überprüft werden. Ihr Konto ist möglicherweise trotzdem verbunden worden. Überprüfen Sie die Verbindungen, bevor Sie es erneut versuchen.',
    providerAuthorizationFailed:
      'Die Autorisierung von {name} wurde beim Anbieter nicht abgeschlossen. Das Konto wurde nicht verbunden. Überprüfen Sie das Anbieterfenster auf einen genaueren Grund und versuchen Sie es dann erneut.',
    providerReturnedMissing:
      'Der Anbieter hat geantwortet, aber {name} ist noch nicht erschienen. Überprüfen Sie, ob das Konto und die angeforderten Berechtigungen genehmigt wurden, und versuchen Sie es dann erneut.',
    notConnected:
      '{name} wurde nicht verbunden. Das Autorisierungsfenster wurde möglicherweise geschlossen oder abgebrochen. Versuchen Sie es erneut, wenn Sie bereit sind.',
    disconnectPrivate:
      '{name} nur für Sie trennen? Der Zugriff wird beendet, bis die Verbindung wiederhergestellt ist.',
    disconnectCompany:
      '{name} für alle bei {company} trennen? Der Zugriff wird beendet, bis die Verbindung wiederhergestellt ist.',
    disconnected: '{name} ist getrennt.',
    disconnectError: 'Die Verbindung konnte nicht getrennt werden.',
    stoppedWaiting:
      'Warten beendet. Ihr Anbieter schließt die Autorisierung möglicherweise noch ab. Öffnen Sie die Verbindungen erneut, um den aktuellen Status zu prüfen.',
    saveSnapshot: 'Snapshot in der Bibliothek speichern',
    requestApproval: 'Genehmigung anfordern',
    accessSuffix: 'Der Zugriff wird beendet, bis die Verbindung wiederhergestellt ist.',
  },
  el: {
    loadError: 'Δεν ήταν δυνατή η φόρτωση των συνδέσεων.',
    startError: 'Δεν ήταν δυνατή η έναρξη της σύνδεσης.',
    providerCheckFailed:
      'Δεν ήταν δυνατός ο έλεγχος του παρόχου αυτήν τη στιγμή. Ο λογαριασμός σας ενδέχεται να έχει συνδεθεί. Ελέγξτε τις Συνδέσεις πριν δοκιμάσετε ξανά.',
    providerAuthorizationFailed:
      'Η εξουσιοδότηση του {name} δεν ολοκληρώθηκε στον πάροχο. Ο λογαριασμός δεν συνδέθηκε. Ελέγξτε το παράθυρο του παρόχου για πιο συγκεκριμένη αιτία και δοκιμάστε ξανά.',
    providerReturnedMissing:
      'Ο πάροχος επέστρεψε, αλλά το {name} δεν έχει εμφανιστεί ακόμη. Βεβαιωθείτε ότι εγκρίθηκαν ο λογαριασμός και τα ζητούμενα δικαιώματα και δοκιμάστε ξανά.',
    notConnected:
      'Το {name} δεν συνδέθηκε. Το παράθυρο εξουσιοδότησης ενδέχεται να έκλεισε ή να ακυρώθηκε. Δοκιμάστε ξανά όταν είστε έτοιμοι.',
    disconnectPrivate:
      'Να αποσυνδεθεί το {name} μόνο για εσάς; Η πρόσβαση διακόπτεται μέχρι να συνδεθεί ξανά.',
    disconnectCompany:
      'Να αποσυνδεθεί το {name} για όλους στην {company}; Η πρόσβαση διακόπτεται μέχρι να συνδεθεί ξανά.',
    disconnected: 'Το {name} αποσυνδέθηκε.',
    disconnectError: 'Δεν ήταν δυνατή η αποσύνδεση.',
    stoppedWaiting:
      'Η αναμονή διακόπηκε. Ο πάροχός σας ενδέχεται να ολοκληρώσει ακόμη την εξουσιοδότηση. Ανοίξτε ξανά τις Συνδέσεις για να ελέγξετε την πιο πρόσφατη κατάσταση.',
    saveSnapshot: 'Αποθήκευση στιγμιότυπου στη Βιβλιοθήκη',
    requestApproval: 'Αίτημα έγκρισης',
    accessSuffix: 'Η πρόσβαση διακόπτεται μέχρι να συνδεθεί ξανά.',
  },
  hu: {
    loadError: 'Nem sikerült betölteni a kapcsolatokat.',
    startError: 'Nem sikerült elindítani a kapcsolatot.',
    providerCheckFailed:
      'Most nem sikerült ellenőrizni a szolgáltatót. Lehet, hogy a fiókod mégis csatlakozott. Ellenőrizd a Kapcsolatokat, mielőtt újra próbálkozol.',
    providerAuthorizationFailed:
      'A(z) {name} engedélyezése nem fejeződött be a szolgáltatónál. A fiók nem lett csatlakoztatva. Nézd meg a szolgáltató ablakát a pontosabb okért, majd próbáld újra.',
    providerReturnedMissing:
      'A szolgáltató válasza megérkezett, de a(z) {name} még nem jelent meg. Ellenőrizd, hogy a fiókot és a kért engedélyeket jóváhagytad-e, majd próbáld újra.',
    notConnected:
      'A(z) {name} nem lett csatlakoztatva. Lehet, hogy az engedélyezési ablakot bezártad vagy megszakítottad. Próbáld újra, amikor készen állsz.',
    disconnectPrivate:
      'Leválasztod a(z) {name} kapcsolatát csak magad számára? A hozzáférés megszűnik, amíg újra nem csatlakoztatod.',
    disconnectCompany:
      'Leválasztod a(z) {name} kapcsolatát {company} minden tagja számára? A hozzáférés megszűnik, amíg újra nem csatlakoztatod.',
    disconnected: 'A(z) {name} le lett választva.',
    disconnectError: 'Nem sikerült leválasztani.',
    stoppedWaiting:
      'Leállítottuk a várakozást. Lehet, hogy a szolgáltatónál még befejeződik az engedélyezés. Nyisd meg újra a Kapcsolatokat a legfrissebb állapot ellenőrzéséhez.',
    saveSnapshot: 'Pillanatkép mentése a Könyvtárba',
    requestApproval: 'Jóváhagyás kérése',
    accessSuffix: 'A hozzáférés megszűnik, amíg újra nem csatlakoztatod.',
  },
  ga: {
    loadError: 'Níorbh fhéidir na naisc a luchtú.',
    startError: 'Níorbh fhéidir an nasc a thosú.',
    providerCheckFailed:
      'Níorbh fhéidir linn an soláthraí a sheiceáil faoi láthair. Seans go bhfuil do chuntas nasctha fós. Seiceáil na Naisc sula ndéanfaidh tú iarracht eile.',
    providerAuthorizationFailed:
      'Níor críochnaíodh údarú {name} ag an soláthraí. Níor nascadh an cuntas. Seiceáil fuinneog an tsoláthraí chun cúis níos sonraithe a fháil, ansin bain triail eile as.',
    providerReturnedMissing:
      'D’fhill an soláthraí, ach níl {name} le feiceáil fós. Seiceáil gur ceadaíodh an cuntas agus na ceadanna iarrtha, ansin bain triail eile as.',
    notConnected:
      'Níor nascadh {name}. Seans gur dúnadh an fhuinneog údaraithe nó gur cuireadh ar ceal í. Bain triail eile as nuair a bheidh tú réidh.',
    disconnectPrivate:
      'Dínasc {name} duitse amháin? Scoirfidh an rochtain go dtí go nascfar arís é.',
    disconnectCompany:
      'Dínasc {name} do chách ag {company}? Scoirfidh an rochtain go dtí go nascfar arís é.',
    disconnected: 'Tá {name} dínasctha.',
    disconnectError: 'Níorbh fhéidir an dínascadh.',
    stoppedWaiting:
      'Stopadh den fanacht. Seans go gcríochnóidh do sholáthraí an t-údarú fós. Oscail na Naisc arís chun an stádas is déanaí a sheiceáil.',
    saveSnapshot: 'Sábháil léargas sa Leabharlann',
    requestApproval: 'Iarr ceadú',
    accessSuffix: 'Scoirfidh an rochtain go dtí go nascfar arís é.',
  },
  it: {
    loadError: 'Impossibile caricare le connessioni.',
    startError: 'Impossibile avviare la connessione.',
    providerCheckFailed:
      'Non è stato possibile verificare il provider in questo momento. Il tuo account potrebbe essere comunque connesso. Controlla Connessioni prima di riprovare.',
    providerAuthorizationFailed:
      "L'autorizzazione di {name} non è stata completata presso il provider. L'account non è stato connesso. Controlla la finestra del provider per un motivo più specifico, quindi riprova.",
    providerReturnedMissing:
      "Il provider ha risposto, ma {name} non è ancora comparso. Verifica che l'account e le autorizzazioni richieste siano stati approvati, quindi riprova.",
    notConnected:
      '{name} non è stato connesso. La finestra di autorizzazione potrebbe essere stata chiusa o annullata. Riprova quando sei pronto.',
    disconnectPrivate:
      "Disconnettere {name} solo per te? L'accesso verrà interrotto finché non verrà connesso di nuovo.",
    disconnectCompany:
      "Disconnettere {name} per tutti gli utenti di {company}? L'accesso verrà interrotto finché non verrà connesso di nuovo.",
    disconnected: '{name} è disconnesso.',
    disconnectError: 'Impossibile disconnettere.',
    stoppedWaiting:
      "Attesa interrotta. Il provider potrebbe completare comunque l'autorizzazione. Riapri Connessioni per controllare lo stato aggiornato.",
    saveSnapshot: 'Salva uno snapshot nella Libreria',
    requestApproval: 'Richiedi approvazione',
    accessSuffix: "L'accesso si interrompe finché non viene nuovamente connesso.",
  },
  lv: {
    loadError: 'Neizdevās ielādēt savienojumus.',
    startError: 'Neizdevās izveidot savienojumu.',
    providerCheckFailed:
      'Šobrīd neizdevās pārbaudīt pakalpojumu sniedzēju. Iespējams, jūsu konts joprojām ir savienots. Pirms mēģināt vēlreiz, pārbaudiet sadaļu Savienojumi.',
    providerAuthorizationFailed:
      '{name} autorizācija pie pakalpojumu sniedzēja netika pabeigta. Konts netika savienots. Lai uzzinātu precīzāku iemeslu, pārbaudiet pakalpojumu sniedzēja logu un pēc tam mēģiniet vēlreiz.',
    providerReturnedMissing:
      'Pakalpojumu sniedzēja logs tika aizvērts, taču {name} vēl nav parādījies. Pārbaudiet, vai konts un pieprasītās atļaujas tika apstiprinātas, un pēc tam mēģiniet vēlreiz.',
    notConnected:
      '{name} netika savienots. Iespējams, autorizācijas logs tika aizvērts vai darbība atcelta. Kad esat gatavs, mēģiniet vēlreiz.',
    disconnectPrivate:
      'Atvienot {name} tikai jums? Piekļuve tiks pārtraukta, līdz tas atkal tiks savienots.',
    disconnectCompany:
      'Atvienot {name} visiem uzņēmumā {company}? Piekļuve tiks pārtraukta, līdz tas atkal tiks savienots.',
    disconnected: '{name} ir atvienots.',
    disconnectError: 'Neizdevās atvienot.',
    stoppedWaiting:
      'Gaidošais process apturēts. Iespējams, jūsu pakalpojumu sniedzējs vēl pabeigs autorizāciju. Atveriet sadaļu Savienojumi vēlreiz, lai pārbaudītu jaunāko statusu.',
    saveSnapshot: 'Saglabāt momentuzņēmumu bibliotēkā',
    requestApproval: 'Pieprasīt apstiprinājumu',
    accessSuffix: 'Piekļuve tiek pārtraukta, līdz savienojums tiek atjaunots.',
  },
  lt: {
    loadError: 'Nepavyko įkelti ryšių.',
    startError: 'Nepavyko pradėti ryšio.',
    providerCheckFailed:
      'Šiuo metu nepavyko patikrinti teikėjo. Jūsų paskyra vis tiek galėjo būti prijungta. Prieš bandydami dar kartą patikrinkite skiltį „Ryšiai“.',
    providerAuthorizationFailed:
      '{name} autorizavimas teikėjo sistemoje nebuvo baigtas. Paskyra neprijungta. Konkretesnės priežasties ieškokite teikėjo lange ir bandykite dar kartą.',
    providerReturnedMissing:
      'Teikėjas grąžino atsaką, tačiau {name} dar nepasirodė. Patikrinkite, ar paskyra ir prašyti leidimai buvo patvirtinti, tada bandykite dar kartą.',
    notConnected:
      '{name} nebuvo prijungta. Autorizavimo langas galėjo būti uždarytas arba atšauktas. Kai būsite pasiruošę, bandykite dar kartą.',
    disconnectPrivate: 'Atjungti {name} tik jums? Prieiga bus sustabdyta, kol vėl prisijungsite.',
    disconnectCompany:
      'Atjungti {name} visiems naudotojams, esantiems {company}? Prieiga bus sustabdyta, kol vėl prisijungsite.',
    disconnected: '{name} atjungta.',
    disconnectError: 'Nepavyko atjungti.',
    stoppedWaiting:
      'Laukimas sustabdytas. Teikėjas vis dar gali baigti autorizavimą. Iš naujo atidarykite skiltį „Ryšiai“ ir patikrinkite naujausią būseną.',
    saveSnapshot: 'Išsaugoti momentinę kopiją bibliotekoje',
    requestApproval: 'Prašyti patvirtinimo',
    accessSuffix: 'Prieiga sustabdoma, kol ryšys bus atkurtas.',
  },
  mt: {
    loadError: 'Ma setgħux jitgħabbew il-konnessjonijiet.',
    startError: 'Ma setgħetx tibda l-konnessjoni.',
    providerCheckFailed:
      "Ma stajniex niċċekkjaw il-fornitur bħalissa. Il-kont tiegħek xorta jista' jkun ġie konness. Iċċekkja l-Konnessjonijiet qabel terġa' tipprova.",
    providerAuthorizationFailed:
      "L-awtorizzazzjoni ta' {name} ma tlestietx għand il-fornitur. Il-kont ma ġiex konness. Iċċekkja t-tieqa tal-fornitur għal raġuni aktar speċifika, imbagħad erġa' pprova.",
    providerReturnedMissing:
      "Il-fornitur wieġeb, iżda {name} għadu ma deherx. Iċċekkja li l-kont u l-permessi mitluba ġew approvati, imbagħad erġa' pprova.",
    notConnected:
      "{name} ma ġiex konness. It-tieqa tal-awtorizzazzjoni setgħet ingħalqet jew ġiet ikkanċellata. Erġa' pprova meta tkun lest.",
    disconnectPrivate: "Skonnettja {name} għalik biss? L-aċċess jieqaf sakemm jerġa' jiġi konness.",
    disconnectCompany:
      "Skonnettja {name} għal kulħadd f'{company}'? L-aċċess jieqaf sakemm jerġa' jiġi konness.",
    disconnected: "Il-konnessjoni ta' {name} inqatgħet.",
    disconnectError: "Ma setgħetx tinqata' l-konnessjoni.",
    stoppedWaiting:
      "Waqaft nistenna. Il-fornitur tiegħek xorta jista' jlesti l-awtorizzazzjoni. Iftaħ mill-ġdid il-Konnessjonijiet biex tiċċekkja l-aħħar stat.",
    saveSnapshot: 'Issejvja snapshot fil-Librerija',
    requestApproval: 'Itlob approvazzjoni',
    accessSuffix: "L-aċċess jieqaf sakemm jerġa' jiġi konness.",
  },
  pl: {
    loadError: 'Nie udało się wczytać połączeń.',
    startError: 'Nie udało się uruchomić połączenia.',
    providerCheckFailed:
      'Nie udało się teraz sprawdzić dostawcy. Twoje konto mogło mimo to zostać połączone. Sprawdź Połączenia przed ponowną próbą.',
    providerAuthorizationFailed:
      'Autoryzacja {name} u dostawcy nie została zakończona. Konto nie zostało połączone. Sprawdź okno dostawcy, aby poznać dokładniejszy powód, a następnie spróbuj ponownie.',
    providerReturnedMissing:
      'Nastąpił powrót od dostawcy, ale {name} nie jest jeszcze widoczne. Sprawdź, czy konto i wymagane uprawnienia zostały zatwierdzone, a następnie spróbuj ponownie.',
    notConnected:
      'Nie udało się połączyć z {name}. Okno autoryzacji mogło zostać zamknięte lub anulowane. Spróbuj ponownie, gdy będziesz gotowy(-a).',
    disconnectPrivate:
      'Odłączyć {name} tylko dla siebie? Dostęp zostanie wstrzymany do czasu ponownego połączenia.',
    disconnectCompany:
      'Odłączyć {name} dla wszystkich w firmie {company}? Dostęp zostanie wstrzymany do czasu ponownego połączenia.',
    disconnected: '{name} zostało odłączone.',
    disconnectError: 'Nie udało się odłączyć.',
    stoppedWaiting:
      'Przerwano oczekiwanie. Dostawca może nadal kończyć autoryzację. Otwórz ponownie Połączenia, aby sprawdzić najnowszy status.',
    saveSnapshot: 'Zapisz migawkę w Bibliotece',
    requestApproval: 'Poproś o zatwierdzenie',
    accessSuffix: 'Dostęp zostanie wstrzymany do czasu ponownego połączenia.',
  },
  pt: {
    loadError: 'Não foi possível carregar as conexões.',
    startError: 'Não foi possível iniciar a conexão.',
    providerCheckFailed:
      'Não foi possível verificar o provedor agora. Sua conta ainda pode ter sido conectada. Verifique as Conexões antes de tentar novamente.',
    providerAuthorizationFailed:
      'A autorização de {name} não foi concluída no provedor. A conta não foi conectada. Verifique a janela do provedor para saber o motivo específico e tente novamente.',
    providerReturnedMissing:
      'O provedor retornou, mas {name} ainda não apareceu. Verifique se a conta e as permissões solicitadas foram aprovadas e tente novamente.',
    notConnected:
      '{name} não foi conectado. A janela de autorização pode ter sido fechada ou cancelada. Tente novamente quando estiver pronto.',
    disconnectPrivate:
      'Desconectar {name} apenas para você? O acesso será interrompido até que seja conectado novamente.',
    disconnectCompany:
      'Desconectar {name} para todos em {company}? O acesso será interrompido até que seja conectado novamente.',
    disconnected: '{name} foi desconectado.',
    disconnectError: 'Não foi possível desconectar.',
    stoppedWaiting:
      'Espera interrompida. Seu provedor ainda pode concluir a autorização. Reabra as Conexões para verificar o status mais recente.',
    saveSnapshot: 'Salvar um instantâneo na Biblioteca',
    requestApproval: 'Solicitar aprovação',
    accessSuffix: 'O acesso será interrompido até que seja conectado novamente.',
  },
  ro: {
    loadError: 'Conexiunile nu au putut fi încărcate.',
    startError: 'Conexiunea nu a putut fi pornită.',
    providerCheckFailed:
      'Nu am putut verifica furnizorul acum. Este posibil ca contul să fie deja conectat. Verifică secțiunea Conexiuni înainte de a încerca din nou.',
    providerAuthorizationFailed:
      'Autorizarea pentru {name} nu s-a finalizat la furnizor. Contul nu a fost conectat. Verifică fereastra furnizorului pentru un motiv mai precis, apoi încearcă din nou.',
    providerReturnedMissing:
      'Furnizorul a răspuns, dar {name} nu a apărut încă. Verifică dacă au fost aprobate contul și permisiunile solicitate, apoi încearcă din nou.',
    notConnected:
      '{name} nu a fost conectat. Este posibil ca fereastra de autorizare să fi fost închisă sau anulată. Încearcă din nou când ești pregătit.',
    disconnectPrivate:
      'Deconectezi {name} doar pentru tine? Accesul se oprește până când este conectat din nou.',
    disconnectCompany:
      'Deconectezi {name} pentru toată lumea de la {company}? Accesul se oprește până când este conectat din nou.',
    disconnected: '{name} este deconectat.',
    disconnectError: 'Deconectarea nu a reușit.',
    stoppedWaiting:
      'Așteptarea a fost oprită. Este posibil ca furnizorul să finalizeze în continuare autorizarea. Redeschide secțiunea Conexiuni pentru a verifica cea mai recentă stare.',
    saveSnapshot: 'Salvează un instantaneu în Bibliotecă',
    requestApproval: 'Solicită aprobare',
    accessSuffix: 'Accesul se oprește până când este conectat din nou.',
  },
  sk: {
    loadError: 'Nepodarilo sa načítať pripojenia.',
    startError: 'Nepodarilo sa spustiť pripojenie.',
    providerCheckFailed:
      'Poskytovateľa sa momentálne nepodarilo overiť. Váš účet môže byť napriek tomu pripojený. Pred ďalším pokusom skontrolujte Pripojenia.',
    providerAuthorizationFailed:
      'Autorizácia pre {name} u poskytovateľa nebola dokončená. Účet nebol pripojený. Skontrolujte okno poskytovateľa, kde nájdete konkrétnejší dôvod, a potom to skúste znova.',
    providerReturnedMissing:
      'Poskytovateľ odpovedal, ale {name} sa zatiaľ nezobrazil. Skontrolujte, či boli účet a požadované povolenia schválené, a potom to skúste znova.',
    notConnected:
      '{name} nebol pripojený. Autorizačné okno mohlo byť zatvorené alebo zrušené. Keď budete pripravení, skúste to znova.',
    disconnectPrivate: 'Odpojiť {name} iba pre vás? Prístup sa zastaví, kým ho znova nepripojíte.',
    disconnectCompany:
      'Odpojiť {name} pre všetkých v spoločnosti {company}? Prístup sa zastaví, kým ho znova nepripojíte.',
    disconnected: '{name} je odpojený.',
    disconnectError: 'Nepodarilo sa odpojiť.',
    stoppedWaiting:
      'Čakanie bolo zastavené. Poskytovateľ môže autorizáciu stále dokončiť. Znova otvorte Pripojenia a skontrolujte najnovší stav.',
    saveSnapshot: 'Uložiť snímku do Knižnice',
    requestApproval: 'Požiadať o schválenie',
    accessSuffix: 'Prístup bude pozastavený, kým sa znova nepripojí.',
  },
  sl: {
    loadError: 'Povezav ni bilo mogoče naložiti.',
    startError: 'Povezave ni bilo mogoče vzpostaviti.',
    providerCheckFailed:
      'Ponudnika trenutno ni bilo mogoče preveriti. Vaš račun je morda vseeno že povezan. Pred ponovnim poskusom preverite Povezave.',
    providerAuthorizationFailed:
      'Avtorizacija za {name} pri ponudniku ni bila dokončana. Račun ni bil povezan. Za natančnejši razlog preverite okno ponudnika in poskusite znova.',
    providerReturnedMissing:
      'Ponudnik je odgovoril, vendar se {name} še ni prikazal. Preverite, ali sta bila račun in zahtevana dovoljenja odobrena, nato poskusite znova.',
    notConnected:
      'Povezave z {name} ni bilo mogoče vzpostaviti. Okno za avtorizacijo je bilo morda zaprto ali preklicano. Poskusite znova, ko boste pripravljeni.',
    disconnectPrivate:
      'Želite prekiniti povezavo z {name} samo zase? Dostop bo onemogočen, dokler povezava ne bo znova vzpostavljena.',
    disconnectCompany:
      'Želite prekiniti povezavo z {name} za vse v {company}? Dostop bo onemogočen, dokler povezava ne bo znova vzpostavljena.',
    disconnected: 'Povezava z {name} je prekinjena.',
    disconnectError: 'Povezave ni bilo mogoče prekiniti.',
    stoppedWaiting:
      'Čakanje je prekinjeno. Vaš ponudnik lahko še vedno dokonča avtorizacijo. Odprite Povezave in preverite najnovejše stanje.',
    saveSnapshot: 'Shrani posnetek v Knjižnico',
    requestApproval: 'Zahtevaj odobritev',
    accessSuffix: 'Dostop bo onemogočen, dokler povezava ne bo znova vzpostavljena.',
  },
  es: {
    loadError: 'No se pudieron cargar las conexiones.',
    startError: 'No se pudo iniciar la conexión.',
    providerCheckFailed:
      'No pudimos comprobar el proveedor en este momento. Es posible que tu cuenta ya se haya conectado. Comprueba Conexiones antes de volver a intentarlo.',
    providerAuthorizationFailed:
      'La autorización de {name} no se completó con el proveedor. La cuenta no se conectó. Comprueba la ventana del proveedor para ver un motivo más específico y vuelve a intentarlo.',
    providerReturnedMissing:
      'El proveedor respondió, pero {name} aún no aparece. Comprueba que la cuenta y los permisos solicitados se hayan aprobado y vuelve a intentarlo.',
    notConnected:
      '{name} no se conectó. Es posible que la ventana de autorización se haya cerrado o cancelado. Vuelve a intentarlo cuando estés listo.',
    disconnectPrivate:
      '¿Desconectar {name} solo para ti? El acceso se detendrá hasta que se vuelva a conectar.',
    disconnectCompany:
      '¿Desconectar {name} para todos en {company}? El acceso se detendrá hasta que se vuelva a conectar.',
    disconnected: '{name} está desconectado.',
    disconnectError: 'No se pudo desconectar.',
    stoppedWaiting:
      'Se dejó de esperar. Es posible que el proveedor aún termine de autorizar. Vuelve a abrir Conexiones para comprobar el estado más reciente.',
    saveSnapshot: 'Guardar una instantánea en la Biblioteca',
    requestApproval: 'Solicitar aprobación',
    accessSuffix: 'El acceso se detiene hasta que vuelva a conectarse.',
  },
  sv: {
    loadError: 'Det gick inte att läsa in anslutningar.',
    startError: 'Det gick inte att starta anslutningen.',
    providerCheckFailed:
      'Det gick inte att kontrollera leverantören just nu. Ditt konto kan fortfarande ha anslutits. Kontrollera Anslutningar innan du försöker igen.',
    providerAuthorizationFailed:
      'Auktoriseringen av {name} slutfördes inte hos leverantören. Kontot anslöts inte. Kontrollera leverantörens fönster för en mer specifik orsak och försök sedan igen.',
    providerReturnedMissing:
      'Leverantören svarade, men {name} har ännu inte dykt upp. Kontrollera att kontot och de begärda behörigheterna godkändes och försök sedan igen.',
    notConnected:
      '{name} anslöts inte. Auktoriseringsfönstret kan ha stängts eller avbrutits. Försök igen när du är redo.',
    disconnectPrivate:
      'Koppla från {name} endast för dig? Åtkomsten stoppas tills den ansluts igen.',
    disconnectCompany:
      'Koppla från {name} för alla på {company}? Åtkomsten stoppas tills den ansluts igen.',
    disconnected: '{name} är frånkopplad.',
    disconnectError: 'Det gick inte att koppla från.',
    stoppedWaiting:
      'Väntan har avbrutits. Din leverantör kan fortfarande slutföra auktoriseringen. Öppna Anslutningar igen för att kontrollera den senaste statusen.',
    saveSnapshot: 'Spara en ögonblicksbild i biblioteket',
    requestApproval: 'Begär godkännande',
    accessSuffix: 'Åtkomsten upphör tills den återansluts.',
  },
} as const;

export default connectionsActionsCopy satisfies NamespaceCatalog<
  keyof typeof connectionsActionsCopy.en
>;
